import Vue from 'vue'
import L from 'leaflet' // Import L explicitly

if (process.client) {
  const { LMap, LTileLayer, LMarker } = require('vue2-leaflet')
  Vue.component('l-map', LMap)
  Vue.component('l-tile-layer', LTileLayer)
  Vue.component('l-marker', LMarker)

  // Import Leaflet default icon images to fix marker display issues
  delete L.Icon.Default.prototype._getIconUrl

  L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
  })
}
